export default {
      id: "about-1-usage",
      viewBox: "0 0 50 50",
      url: "/" + "assets/sprite.svg#about-1",
      toString: function () {
        return this.url;
      }
    }